import { memo } from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import _truncate from 'lodash/truncate';
import _upperCase from 'lodash/upperCase'
import _startCase from 'lodash/startCase'
import _get from 'lodash/get'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import useProductInfo from '../modules/FastSpringStore/useProductInfo';
import ProductPriceDisplay from '../components/ProductPriceDisplay';
import BuyNowBtn from 'components/BuyNowBtn';
import useFastSpringStore from '../modules/FastSpringStore/useFastSpringStore';
import { faArrowRight, faCheck, faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import RemoveButton from '../components/RemoveButton';


export default memo(({ onClick, link, img, imgAlt, title, description, fastspring_id, fastspring_id_mac, fastspring_id_pc, category, featured, className='' }) => {
  const productInfo = fastspring_id === "" ? useProductInfo(fastspring_id_mac) : useProductInfo(fastspring_id)
  const [{ productsInCart }] = useFastSpringStore()
  return (
    <div className={`col-md-4 col-sm-6 col-12 mb-5 ${className}`}>
      <div className="card m-0 h-100 position-relative border-0 shadow">
        {featured && (
          <h5
            className="position-absolute"
            style={{
              top: '-8px',
              right: '5px',
              zIndex: 1
            }}
          >
            <span
              className="badge bg-warning text-white"
            >
                <FontAwesomeIcon
                  icon={faStar}
                  className="mr-1"
                />
                BESTSELLER
            </span>
          </h5>
        )}
        <Link to={link} className="text-center bg-white">
          <GatsbyImage
            imgClassName="card-img-top"
            image={getImage(img)}
            alt={imgAlt}
            placeholder="blurred"
          />
        </Link>
        <div
          className="card-body pb-0 position-relative bg-transparent"
          style={{
            cursor: 'pointer'
          }}
        >
          <span
            className="badge bg-dark text-white position-absolute"
            style={{
              top: '-10px',
              right: '10px',
              fontSize: '1rem'
            }}
          >
            {_upperCase(_startCase(category))}
          </span>
          <Link
            to={link}
            style={{
              color: 'var(--main-text-color)',
              textDecoration: 'none',
            }}
          >
            <h5>
              { title }
            </h5>
            <p className="secondary-text-color">
              { _truncate(description, {
                length: 60,
                separator: /,? +/
              })}
            </p>
          </Link>
        </div>
        <div className="card-footer bg-transparent">
          <div className="d-flex justify-content-center align-items-center mb-2">
            <ProductPriceDisplay
              price={_get(productInfo, 'priceTotal')}
              finalPrice={_get(productInfo, 'total')}
            />
          </div>
          {
            productsInCart.includes(fastspring_id_mac) && productsInCart.includes(fastspring_id_pc) ? 
            <div>
              <div class="row">
                <div class="col">
                  <Link to="/cart" className='btn btn-danger learn-more-btn btn-block'>
                    <>
                      <FontAwesomeIcon
                        icon={faShoppingCart}
                        className="mr-2"
                        />
                      To checkout
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="ml-2"
                        />
                    </>
                  </Link>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <small className="mt-3 d-block text-muted text-center">
                    <span className="mr-2">
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="mr-2"
                      />
                      Added both to cart
                    </span>
                    <br/>
                    <RemoveButton
                      productId={fastspring_id_mac}
                      className="mr-1"
                    >Remove Mac</RemoveButton>
                    <RemoveButton
                      productId={fastspring_id_pc}
                    >Remove PC</RemoveButton>
                  </small>
                </div>
              </div>
            </div>
            :
            fastspring_id === "" ?    
            <>           
              <BuyNowBtn
                fastspringId={fastspring_id_mac}
                className="learn-more-btn btn-block"
                onClick={onClick}
                icon='mac'
              />
              <BuyNowBtn
                fastspringId={fastspring_id_pc}
                className="learn-more-btn btn-block"
                onClick={onClick}
                icon='pc'
              />
            </>
            : 
            <BuyNowBtn
                fastspringId={fastspring_id}
                className="learn-more-btn btn-block"
                onClick={onClick}
              />
          }
        </div>
      </div>
    </div>
  )
})
